import { createGlobalStyle } from 'styled-components'

const INTERCOM_FULLSCREEN_MAX_WIDTH_PX = 450

export const IntercomMessengerPositionStyled = createGlobalStyle`
  @media (min-width: ${INTERCOM_FULLSCREEN_MAX_WIDTH_PX + 1}px) {
    .intercom-messenger-frame {
      top: calc(
        ${(props) => props.theme.appHeader.height} +
          ${(props) => props.theme.space.small}
      ) !important;
      bottom: auto !important;
      max-height: calc(
        100vh - ${(props) => props.theme.appHeader.height} -
          ${(props) => props.theme.space.small} * 2
      ) !important;
      transform-origin: right top !important;
    }
  }
`
